import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main';

export const BecomeAffiliate = () => {
  return (
    <>
      <DocumentHead title="Become an Affiliate" />
      <PageTemplate main={<Main />} />
    </>
  );
};
